// 首页搜索框
import React from 'react'
import SearchBoxStyle from './styles/SearchBoxStyle'
import { withStyles } from '@zn-material-ui'
import home_icon_searchImage from '@images/homepage/home_icon_searchImage.png'
import { inject, observer } from 'mobx-react'
import { getOriginFromUrl, getUrlParam } from '@utils'
import { transform } from '@utils/intl_lang'
export interface IProps {
  classes: any
  history: any
  Search: any
  routeParam: any
}
@inject('UserStore', 'Search')
@observer
class SearchBox extends React.Component<any, any> {
  private input: any
  constructor(props: any) {
    super(props)
    this.input = React.createRef()
    this.state = {
      searchWord: decodeURIComponent(getUrlParam('searchWord') || ''),
      routeParam: 'search',
      dataList: [],
      pageNumber: 1,
      loading: false,
      haveMore: true,
      dataArr: [],
      index: -1,
    }
  }

  public valueChange = (e: any) => {
    this.setState({ searchWord: e.target.value })
    this.props.Search.updateSearchWord(e.target.value)
  }

  public handleEnterKey = (e: any) => {
    if (e.nativeEvent.keyCode === 13) {
      // e.nativeEvent获取原生的事件对像
      this.onSearch()
    }
  }

  public onSearch = () => {
    const val = this.input.value
    if (!val.trim()) {
      return
    }
    this.props.Search.updateSearchWordAfter(this.props.Search.searchWord)
    this.props.Search.updateRouteParam('search')
    this.goToPage('/home/search')
    this.props.Search.getAllList()
  }

  public render() {
    const { classes } = this.props
    return (
      <div className={classes.container}>
        <input
          className={classes.input}
          type="text"
          // "请输入搜索关键字/直播ID/短视频ID"
          placeholder={transform('enter_search_keywords')}
          title={transform('enter_search_keywords')}
          defaultValue={this.state.searchWord}
          onChange={this.valueChange}
          onKeyPress={this.handleEnterKey}
          ref={input => (this.input = input)}
          disabled={this.props.disabled}
        />
        <div className={classes.searchImg} onClick={this.onSearch}>
          <img alt="xtb" src={home_icon_searchImage} />
          {/* 搜索 */}
          <span>{transform('search')}</span>
        </div>
      </div>
    )
  }

  private goToPage = (url: string) => {
    const origin = this.getOrigin()
    if (origin) {
      const prefix = origin.includes('localhost')
        ? origin
        : `${origin}/znWeb/znPortal`
      location.href = `${prefix}/#${url}`
    } else {
      this.props.history.push(url)
    }
  }

  private isExamDetailPage = () => {
    return location.href.includes('/home/examDetail')
  }

  // 因为考试页比较特殊，在考试页跳转需要从url上获取origin
  private getOrigin: () => string = () => {
    if (this.isExamDetailPage()) {
      return getOriginFromUrl() || ''
    }
    return ''
  }
}
export default withStyles(SearchBoxStyle)(SearchBox)
